

  if (navigator.userAgent.match('MSIE 10.0;') || navigator.userAgent.match('MSIE 9.0;') || navigator.userAgent.match('MSIE 8.0;') || navigator.userAgent.match('MSIE 7.0;')) {
    if ($.cookie('popupIE') !== "visible") {
        $.cookie('popupIE', 'visible');
        $("body").addClass("popup-IE");
        $("#popupIE9-10").modal("show");
    }
  }


